@if ((form && fieldName) || schema === null) {
  <div style="min-width: 223px">
    <div>
      <p-float-label>
        <p-inputgroup>
          <ng-template [ngTemplateOutlet]="prefix"></ng-template>
          @if ((cacheParameters | async)?.isLoading || !keyProperty || !displayProperty) {
            <div style="height: 43.2px; width: 100%" class="overflow-hidden">
              <p-skeleton width="100%" height="43.2px" styleClass="mb-2" /><br />
              <span class="absolute top-4 right-2 z-10">
                <i class="pi spin autorenew s-loader"></i>
              </span>
            </div>
          } @else {
            <!--
       [formGroup]="form"
            class="flex"
            autocompleteLabel
            [formControlName]="fieldName ?? null"
            -->
            <p-autoComplete
              #input
              [id]="fieldName"
              [inputId]="inputId"
              appendTo="body"
              [(ngModel)]="formData"
              (ngModelChange)="formChanged($event)"
              [showClear]="!(isRequired() || readonly)"
              [suggestions]="(filteredOptions$ | async) ?? []"
              [dropdown]="!readonly"
              [readonly]="readonly"
              [showEmptyMessage]="true"
              [s-blur]="attribute?.dataClassification"
              [emptyMessage]="'No Results Found.'"
              (onAdd)="onAdd()"
              [required]="isRequired()"
              [multiple]="multiple"
              [class.w-full]="multiple"
              (onFocus)="onFocus()"
              (onSelect)="onSelection($event)"
              (onDropdownClick)="onDropDownClick($event)"
              [autoHighlight]="false"
              (onClear)="onClear()"
              (onBlur)="onBlur($event)"
              (completeMethod)="queryFilter($event)"
              [placeholder]="label ? undefined : 'Enter ' + defaultText"
              [optionLabel]="displayFn.bind(this)"
              [forceSelection]="false"
            >
              <ng-template let-option #item>
                @if (option.priorityItem) {
                  <span class="font-bold">★ {{ option.__display }}</span>
                } @else {
                  <span>{{ option.__display }}</span>
                }
              </ng-template>
            </p-autoComplete>
          }
          <label [htmlFor]="fieldName" [class.ml-2]="(cacheParameters | async)?.isLoading"
            >{{ label }}
            @if (isRequired()) {
              <span style="color: red">*</span>
            }
          </label>
          <ng-template [ngTemplateOutlet]="suffix"></ng-template>
        </p-inputgroup>
      </p-float-label>
    </div>
    <div>
      @if (displayHint) {
        <small class="block">{{ displayHint }}</small>
      }
      <s-form-error-input
        [groupName]="groupName"
        [fieldName]="fieldName"
        [form]="form"
        [apiError]="apiError"
        [schema]="schema"
      />
    </div>
  </div>
}
